module.exports = __webpack_public_path__ + "static/media/3.5b81afea.png";